import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot,faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import {Link} from 'react-router-dom';
const LandingFooter = () => {
    return (
        <>
            <footer className="footer-area style-2 bg-light mt-6">
                <div className="container">
                    <div className="footer-area-inner">
                        <div className="row">
                            <div className='col-md-6'>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className="footer-widget-wrapper">
                                            <div className="footer-logo">
                                                <Link to="/">
                                                    <img src="/truvoice_logo-new.png" alt="site-logo"/>
                                                </Link>
                                            </div>
                                            <div className="description-text mt-5">
                                                <div className="text-wrapper">
                                                    <p className="text fs-5">Julien Innovations is a Conversational AI platform company. TruAssist, the AI platform, is among the best anywhere. We also have deep expertise in NLP, Speech, RPA, Product Development and Analytics.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-6' >
                                        <div className="footer-single-col" style={{margin:'auto', display:'table'}}>
                                            <h3 className='text-gray-700 mb-5 fs-1'>Quick links</h3>
                                            <ul className="list-unstyled footer-nav-list mb-lg-0 quick-links">
                                                {/* <li>
                                                    <Link to="#" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        About Us
                                                    </Link>
                                                </li> */}
                                                <li>
                                                    <Link to="/contact" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        Contact
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        Careers
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/terms-and-conditions" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        Terms of Use
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="#" className="text-gray-600 fs-5" style={{lineHeight:'30px'}}>
                                                        News &amp; Media
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className="footer-single-col">
                                    <h3 className='text-gray-700 mb-10 fs-1'>Julien Innovations India Pvt. Ltd.</h3>
                                    <div className="col-md-12 col-lg-12  d-flex">
                                        <div className="col-md-4 col-lg-5">
                                            <h4 className="fs-6 text-gray-700 mb-4">India Office</h4>
                                            <ul className="list-unstyled footer-nav-list mb-lg-0">
                                                <li>
                                                    <a className='text-gray-600 fs-6 d-flex ' style={{lineHeight:'24px'}}>
                                                        <FontAwesomeIcon icon={faLocationDot} className='fs-3 text-primary me-2' /> 
                                                        <span className='mt-m5'>2nd Floor, 20, Inorbit Mall Rd, Mindspace Rd, Vittal Rao Nagar, Madhapur, Telangana 500081</span>
                                                    </a>
                                                </li>
                                                <li className='mt-3'>
                                                    <a className='text-gray-600 fs-6 '>
                                                        <FontAwesomeIcon icon={faEnvelope} className='fs-3 text-primary me-2' />
                                                        <span className='mt-m5'>sales@truvoice.ai </span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-md-2 col-lg-2"></div>
                                        <div className="col-md-4 col-lg-5">
                                            <h4 className="fs-6 text-gray-700 mb-4 ">USA Office</h4>
                                            <ul className="list-unstyled footer-nav-list mb-lg-0">
                                                <li>
                                                    <a className='text-gray-600 fs-6 d-flex '>
                                                        <FontAwesomeIcon icon={faLocationDot} className='fs-3 text-primary me-2'/>  
                                                        <span className='mt-m5'>3381 Lovage Dr, Apex, NC -27502, USA </span>
                                                    </a>
                                                </li>
                                                <li className='mt-3'>
                                                    <a className='text-gray-600 fs-6 d-flex '>
                                                        <FontAwesomeIcon icon={faEnvelope} className='fs-3 text-primary me-2'/> 
                                                        <span className='mt-m5'>sales@truvoice.ai</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="copyright-area-inner">
                        <ul className="social-links">
                            <li>
                                <Link to="#">
                                    <i className="fa-brands fa-facebook-f fs-5"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fa-brands fa-twitter fs-5"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fa-brands fa-instagram fs-5"></i>
                                </Link>
                            </li>
                            <li>
                                <Link to="#">
                                    <i className="fa-brands fa-linkedin fs-5"></i>
                                </Link>
                            </li>
                        </ul>
                        <div className="copyright-text">
                            <p className="text fs-7">© {new Date().getFullYear()}{' '}
                                <Link to="#" className="text-gray-700 fs-5">
                                    Julien Innovations India Pvt. Ltd.
                                </Link>
                                All Rights Reserved.
                            </p>
                            {/* <p className="text fs-7">
                                Technology Partner
                                <Link to="https://softamassindia.com/" className="text-gray-700 fs-5 ms-1">
                                    Soft Amass India
                                </Link>
                            </p> */}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default LandingFooter